import React, { useContext, useEffect, useState, Fragment } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Menu,
    MenuItem,
    Rating,
    Snackbar,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Typography,
    Tooltip,
    Fade,
    useTheme,
    useMediaQuery,
    Stack,
    ThemeProvider,
    Box,
    Slide
} from "@mui/material";
import CurrencyFormat from "react-currency-format";
import ChatIcon from "@mui/icons-material/Chat";
import { Link } from "react-router-dom";
import { getCurrencySymbol, getCurrencySymbolFromParam } from "../utils";
import { graphql, graphqlOperation } from "../modules/AmplifyServices";
import { clientByUserId } from "../queries/ListBookingsQueries";
import * as queries from "../graphql/queries";
import { MoreHoriz } from "@mui/icons-material";
import {
    getUserFromCache,
    userCanCancelAppt,
    userHasClientRole
} from "../user/UserCommon";
import ProviderRescheduleModal from "./RescheduleModal";
import ClientRescheduleModal from "./ClientReschedulingModal";
import { StoreContext } from "../context/StoreContext";
import {
    getTableRowsSession,
    setTableRowsSession
} from "../utils/Common/TableRowsSession";
import {
    isMbxUserClient,
    isMbxUserVerifiedStaff,
    mbxUserAtom
} from "../atoms/atoms";
import { useAtom } from "jotai";
import MobileBookingCard from "./mobile/MobileBookingCard";
import { MobileBookingsTheme } from "../styles/MobileBookingsTheme";
import moment from "moment";
import { groupByBookingDate } from "../modules/BookingService";
import { DialogTheme } from "../styles/DialogTheme";
import ManageBookingDialog from "./ManageBookingDialog";
import {
    selectedBookingForRescheduleAtom,
    selectedRescheduleDateTimeAtom
} from "../atoms/providerReschedule";
import {
    openManageBookingDialogAtom,
    selectedBookingAtom
} from "../atoms/bookingsTable";
import ProviderRecurringRescheduleChoiceModal from "./ProviderRecurringRescheduleChoiceModal";
import { selectedCourseBookingAtom } from "../atoms/course";
import { MB_SERVICE_CLASSIFICATION_GROUP } from "../utils/Constants";

const BookingTableTheme = {
    borderCollapse: "separate",
    borderSpacing: "0px 4px",
    //Table Head
    "& .MuiTableHead-root": {
        "& .MuiTableRow-root": {
            "& .MuiTableCell-root": {
                color: "rgba(0,0,0,0.5)",
                paddingBottom: "0.5rem",
                fontWeight: 400
            }
        }
    },

    //Table Body
    "& .MuiTableBody-root": {
        "& .MuiTableRow-root": {
            backgroundColor: "white",
            "&:hover": {
                backgroundColor: "primary.light"
            },
            "& .MuiTableCell-root": {
                fontSize: "0.875rem",

                "& .MuiTypography-root": {
                    fontSize: "0.875rem"
                }
            }
        },
        "& .MuiTableRow-root td:first-of-type": {
            borderTopLeftRadius: "8px",
            borderBottomLeftRadius: "8px"
        },

        "& .MuiTableRow-root td:last-child": {
            borderTopRightRadius: "8px",
            borderBottomRightRadius: "8px"
        }
    },

    //MuiTableFooter  :
    "& .MuiTableFooter-root": {
        "& .MuiTableRow-root": {
            "& .MuiTableCell-root": {
                "& .MuiToolbar-root": {
                    "& .MuiInputBase-root": {
                        fontWeight: 700
                    },
                    "& .MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":
                        {
                            color: "rgba(0,0,0,0.5)"
                        },
                    "& .MuiTablePagination-actions": {
                        display: "flex",
                        gap: "0.5rem",
                        "& button": {
                            border: "1px solid rgba(0,0,0,0.2)",
                            borderRadius: "4px"
                        },

                        "& button:hover": {
                            backgroundColor: "primary.light"
                        }
                    }
                }
            }
        }
    }
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
});

function DropDown(props) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [isVerifiedStaff] = useAtom(isMbxUserVerifiedStaff);

    const handleThreeDotsClose = () => {
        setAnchorEl(null);
        //setSelectedOrder('');
    };

    const showRescheduleOption = () => {
        const loggedInUser = getUserFromCache();

        if (loggedInUser?.role === "PROVIDER") {
            if (
                loggedInUser?.company?.providerCanReschedule &&
                props.row.status === "SCHEDULED"
            ) {
                //make this true to show reschedule option
                return true;
            }
        }

        if (loggedInUser?.role === "CLIENT") {
            if (
                loggedInUser?.company?.clientCanReschedule &&
                props.row.status === "SCHEDULED"
            ) {
                //make this true to show reschedule option
                return true;
            }
        }
        //make it false to hide
        return false;
    };
    return (
        <div>
            <MoreHoriz
                sx={{ cursor: "pointer" }}
                onClick={(e) => {
                    setAnchorEl(e.currentTarget);

                    /*  props.handleThreeDotsClick(
                        e
                       
                    ); */
                }}
            />

            <Menu
                PaperProps={{
                    style: {
                        width: 150,
                        border: "1px solid #e5e5e5",
                        boxShadow: "1px 1px #e5e5e5"
                    }
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleThreeDotsClose}
            >
                {props.row.status === "SCHEDULED" && !userHasClientRole() && (
                    <MenuItem
                        sx={{ fontWeight: 700, color: "#0087EE" }}
                        onClick={() => {
                            props.handleArrived(props.row);
                            handleThreeDotsClose();
                        }}
                    >
                        Arrived
                    </MenuItem>
                )}
                {showRescheduleOption() && (
                    <MenuItem
                        sx={{ fontWeight: 700, color: "#FF681D" }}
                        onClick={() => {
                            //const loggedInUser = getUserFromCache();
                            props.getSelectedRow(props.row.id);
                            /* if(loggedInUser.role === 'PROVIDER'){
                                props.setProviderRescheduleModal(true)
                            } */
                            if (props.row.orderType === "ONGOING") {
                                props.setShowGetRecurringBookingRescheduleChoiceModal(
                                    true
                                );
                            } else props.openRescheduleModal();
                            handleThreeDotsClose();
                            // console.log("LoggedInUser", loggedInUser);
                        }}
                    >
                        Reschedule
                    </MenuItem>
                )}
                {(props.row.status === "ARRIVED" ||
                    props.row.status === "COMPLETED") &&
                    !userHasClientRole() && (
                        <MenuItem
                            sx={{ fontWeight: 700, color: "#0087EE" }}
                            onClick={() => {
                                props.handleAddCharge(props.row);
                                handleThreeDotsClose();
                            }}
                        >
                            Add Charge
                        </MenuItem>
                    )}
                {props.row.status === "ARRIVED" && !userHasClientRole() && (
                    <MenuItem
                        sx={{ fontWeight: 700, color: "rgba(0,0,0,0.8)" }}
                        onClick={() => {
                            props.handleCompleted(props.row);
                            handleThreeDotsClose();
                        }}
                    >
                        Completed
                    </MenuItem>
                )}
                {props.row.status === "SCHEDULED" && userCanCancelAppt() && (
                    <MenuItem
                        sx={{ fontWeight: 700, color: "rgba(0,0,0,0.8)" }}
                        onClick={() => {
                            props.handleCancel(props.row);
                            //props.refreshTable();
                            handleThreeDotsClose();
                        }}
                    >
                        Cancel
                    </MenuItem>
                )}
                {isVerifiedStaff &&
                    !(
                        props.row.status === "COMPLETED" ||
                        props.row.status === "CANCELLED"
                    ) && (
                        <MenuItem
                            sx={{ fontWeight: 700, color: "#8B0000" }}
                            onClick={() => {
                                props.handleOverride(props.row);
                                handleThreeDotsClose();
                            }}
                        >
                            Edit
                        </MenuItem>
                    )}
            </Menu>
        </div>
    );
}

function BookingsFutureTabTable(props) {
    const [mbxUser] = useAtom(mbxUserAtom);
    const [, setSelectedBooking] = useAtom(selectedBookingForRescheduleAtom);
    const [isVerifiedStaff] = useAtom(isMbxUserVerifiedStaff);
    const [userIsClient] = useAtom(isMbxUserClient);
    const { state, actions } = useContext(StoreContext);
    //Virtual Link States
    const [openVMDialog, setOpenVMDialog] = useState(false);
    const [serviceDesc, setServiceDesc] = useState("");
    const [serviceProv, setServiceProv] = useState("");
    const [startDate, setStartDate] = useState("");
    const [serviceLoc, setServiceLoc] = useState("");
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"), {
        defaultMatches: true
    });
    const [openManageBookingDialog, setOpenManageBookingDialog] = useAtom(
        openManageBookingDialogAtom
    );
    const [selectedBooking] = useAtom(selectedBookingAtom);
    const [, setSelectedRescheduleDateTime] = useAtom(
        selectedRescheduleDateTimeAtom
    );

    //snackbar
    const [msgOpen, setMsgOpen] = React.useState(false);
    const [snackMsg, setSnackMsg] = React.useState("");

    //Table Pagination States
    const [page, setPage] = React.useState(0);
    const [selectAll, setSelectAll] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(
        getTableRowsSession("bookingsTable")
    );
    const [
        showGetRecurringBookingRescheduleChoiceModal,
        setShowGetRecurringBookingRescheduleChoiceModal
    ] = useState(false);
    const [rescheduleModal, setRescheduleModal] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);

    const [providerReScheduleModal, setProviderRescheduleModal] =
        useState(false);
    const [clientRescheduleModal, setClientRescheduleModal] = useState(false);
    const [, setSelectedCourseBooking] = useAtom(selectedCourseBookingAtom);

    //const [canProviderReschedule, setCanProviderReschedule] =  useState(false)
    useEffect(() => {
        const loggedInUser = getUserFromCache();
        if (loggedInUser.role === "PROVIDER") {
            setProviderRescheduleModal(true);
        }
    }, [props.rows]);

    const loggedInUser = getUserFromCache();

    //rescheduleModal - provider , clientRescheduleModal - client
    const openRescheduleModal = () => {
        if (loggedInUser?.role === "PROVIDER") {
            setRescheduleModal(true);
        }

        if (loggedInUser?.role === "CLIENT") {
            setClientRescheduleModal(true);
        }
    };

    const closeRescheduleModal = () => {
        setOpenManageBookingDialog(false);

        if (loggedInUser?.role === "PROVIDER") {
            setRescheduleModal(false);
        }

        if (loggedInUser?.role === "CLIENT") {
            setClientRescheduleModal(false);
        }
        setSelectedBooking(null);
    };

    const openSnackbar = (msg) => {
        setSnackMsg(msg);
        setMsgOpen(true);
    };

    const getSelectedRow = (id) => {
        let filter = props?.rows.filter((item) => id === item.id);
        console.log("Selected Row", filter[0]);
        setSelectedRowData(filter[0]);
        setSelectedBooking(filter[0]);
        return filter[0];
    };

    function handleChangePage(event, newPage) {
        setPage(newPage);
    }

    function handleChangeRowsPerPage(event) {
        if (getTableRowsSession("bookingsTable")) {
            setTableRowsSession("bookingsTable", event.target.value);
        }

        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
    }

    //Function to retrieve client data using a userId
    const getOrderData = async (orderId) => {
        try {
            let orderData = await graphql(
                graphqlOperation(queries.getOrder, {
                    id: orderId
                })
            );
            if (orderData && orderData.data.getOrder) {
                orderData = orderData.data.getOrder;
                if (orderData.Notes) {
                    orderData.Notes = orderData.Notes
                        ? JSON.parse(orderData.Notes)
                        : null;
                }
                /* console.log("this is the order data: ", orderData); */
                return orderData;
            } else {
                console.log("ERROR: No order found for order ID ", orderId);
            }
        } catch (e) {
            console.log(
                "ERROR: unable to retrieve order data using orderId ",
                orderId,
                e
            );
        }
    };

    //Function to retrieve client data using a userId
    const getClientData = async (userId, user) => {
        try {
            let clientData = await graphql(
                graphqlOperation(clientByUserId, {
                    userId: userId
                })
            );
            if (clientData && clientData.data.clientByUserId.items) {
                clientData = clientData.data.clientByUserId.items[0];
                clientData.user = user;
                /* console.log("this is the client profile: ", clientData); */
                return clientData;
            }
        } catch (e) {
            console.log(
                "ERROR: unable to retrieve client data using userId ",
                user.id,
                e
            );
        }
    };

    const handleThreeDotsClick = (event) => {
        //setSelectedProvider(providerId.toString());
        //setAnchorEl(event.currentTarget);
    };

    const handleProviderPermalinkClick = (permalink) => {
        const subdomain = mbxUser.company.subdomain;
        if (permalink) {
            window.open(
                `https://${subdomain}/providers/${permalink}`,
                "_blank"
            );
        }
    };

    const handleOpenVirtualBookingModal = (row) => {
        let vmLink = row.provider.vmlink ? row.provider.vmlink : "N/A";
        setServiceDesc(row.desc);
        setServiceProv(row.providerName);
        setStartDate(row.startDateDesc);
        setServiceLoc(vmLink);
        setOpenVMDialog(true);
    };

    const groupedBookings = groupByBookingDate(
        props.rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    );

    return (
        <>
            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
                open={msgOpen}
                autoHideDuration={5000}
                onClose={() => setMsgOpen(false)}
                ContentProps={{
                    "aria-describedby": "message-id"
                }}
                message={<span id="message-id">{snackMsg}</span>}
            />
            <ThemeProvider theme={DialogTheme(theme)}>
                {selectedBooking && (
                    <ManageBookingDialog
                        open={openManageBookingDialog}
                        onClose={() => setOpenManageBookingDialog(false)}
                        TransitionComponent={Transition}
                        updateLocalBooking={props.handleUpdateLocalBooking}
                        onSaveNotes={props.onSaveNotes}
                        handleCancel={props.handleCancel}
                        handleCompleted={props.handleCompleted}
                        handleAddCharge={props.handleAddCharge}
                        handleOverride={props.handleOverride}
                        openRescheduleModal={openRescheduleModal}
                        setSelectedRowData={setSelectedRowData}
                    />
                )}
            </ThemeProvider>
            <Dialog
                open={openVMDialog}
                onClose={() => setOpenVMDialog(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Would you like to join this meeting room?
                </DialogTitle>
                <DialogContent>
                    <div>
                        <span>Service Description:</span> {serviceDesc}
                        <br />
                        <span>Provider:</span> {serviceProv}
                        <br />
                        <span>Starting Date:</span> {startDate}
                        <br />
                        <span>Location: </span>
                        <Link target="_blank" href={serviceLoc}>
                            {serviceLoc}
                        </Link>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setOpenVMDialog(false)}
                        color="primary"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            window.open(`${serviceLoc}`, "_blank");
                            setOpenVMDialog(false);
                        }}
                        color="primary"
                        autoFocus
                    >
                        Join
                    </Button>
                </DialogActions>
            </Dialog>

            {isDesktop || userIsClient ? (
                <TableContainer sx={BookingTableTheme}>
                    <TableHead>
                        <TableRow>
                            {/*headers &&
                                headers.length > 0 &&
                                headers.map((item, index) => {
                                    return <TableCell>{item.title}</TableCell>;
                                })*/}
                            {/* Future Tab With All Headers*/}
                            <TableCell>Description</TableCell>
                            <TableCell>Booking Location</TableCell>
                            {props.role !== "CLIENT" && (
                                <TableCell sx={{ minWidth: "170px" }}>
                                    Client
                                </TableCell>
                            )}
                            {props.role !== "PROVIDER" && (
                                <TableCell>Provider</TableCell>
                            )}
                            <TableCell sx={{ minWidth: "140px" }}>
                                Start Date
                            </TableCell>
                            <TableCell sx={{ minWidth: "125px" }}>
                                Date Created
                            </TableCell>
                            <TableCell>Status</TableCell>
                            {props.role !== "PROVIDER" && (
                                <TableCell>Initial Charge</TableCell>
                            )}
                            {props.role !== "PROVIDER" && (
                                <TableCell>Additional Charges</TableCell>
                            )}
                            {props.role !== "PROVIDER" && (
                                <TableCell>Ratings</TableCell>
                            )}
                            {props.role !== "CLIENT" && (
                                <TableCell sx={{ minWidth: "80px" }}>
                                    Notes
                                </TableCell>
                            )}
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {props.rows
                            .slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                            )
                            .map((row, index) => {
                                return (
                                    <TableRow key={row.id}>
                                        <TableCell>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "0.5rem"
                                                }}
                                            >
                                                <span>{row.desc}</span>
                                                {row.orderType ===
                                                    MB_SERVICE_CLASSIFICATION_GROUP && (
                                                    <span>
                                                        <Typography
                                                            sx={{
                                                                fontStyle:
                                                                    "italic"
                                                            }}
                                                        >{`Class ${row.courseInfo.sessionNo} of ${row.courseInfo.numberOfSessions}`}</Typography>
                                                    </span>
                                                )}
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            {row.location &&
                                            row.location.includes(
                                                "Virtual Appointment"
                                            ) ? (
                                                <Typography
                                                    sx={{
                                                        color: "primary.main",
                                                        cursor: "pointer"
                                                    }}
                                                    style={{ fontWeight: 700 }}
                                                    onClick={() =>
                                                        handleOpenVirtualBookingModal(
                                                            row
                                                        )
                                                    }
                                                >
                                                    {row.location}
                                                </Typography>
                                            ) : (
                                                <Typography
                                                    sx={{
                                                        color: "primary.main",
                                                        cursor: "pointer"
                                                    }}
                                                    style={{ fontWeight: 700 }}
                                                    onClick={() => {
                                                        window.open(
                                                            `https://www.google.com/maps/search/?api=1&query=${row.location.replaceAll(
                                                                " ",
                                                                "+"
                                                            )}`,
                                                            "_blank"
                                                        );
                                                    }}
                                                >
                                                    {row.location
                                                        ? row.location
                                                        : "N/A"}
                                                </Typography>
                                            )}
                                        </TableCell>
                                        {props.role !== "CLIENT" && (
                                            <TableCell>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: "0.5rem"
                                                    }}
                                                >
                                                    {row.orderType ===
                                                        MB_SERVICE_CLASSIFICATION_GROUP &&
                                                    row.courseInfo ? (
                                                        <span>
                                                            <Typography
                                                                sx={{
                                                                    textDecoration:
                                                                        "underline",
                                                                    "&:hover": {
                                                                        cursor: "pointer"
                                                                    }
                                                                }}
                                                                onClick={() => {
                                                                    setSelectedCourseBooking(
                                                                        row
                                                                    );
                                                                    props.showCourseManifest(
                                                                        true
                                                                    );
                                                                }}
                                                            >
                                                                {`${row.courseInfo.seats.used} / ${row.courseInfo.seats.total} spots booked`}
                                                            </Typography>
                                                        </span>
                                                    ) : (
                                                        <>
                                                            <span
                                                                onMouseEnter={(
                                                                    e
                                                                ) => {
                                                                    e.target.style.textDecoration =
                                                                        "underline";
                                                                }}
                                                                onMouseLeave={(
                                                                    e
                                                                ) => {
                                                                    e.target.style.textDecoration =
                                                                        "none";
                                                                }}
                                                                onClick={async () => {
                                                                    props.showClientDialog(
                                                                        row.client
                                                                    );
                                                                }}
                                                                style={{
                                                                    fontFamily:
                                                                        "Roboto",
                                                                    cursor: "pointer"
                                                                }}
                                                            >
                                                                {row.clientName}
                                                            </span>

                                                            <Typography
                                                                sx={{
                                                                    color: "primary.main",
                                                                    cursor: "pointer"
                                                                }}
                                                                style={{
                                                                    fontWeight: 600
                                                                }}
                                                                onClick={() =>
                                                                    window.open(
                                                                        `tel:${props.checkingPhoneNumber(
                                                                            row
                                                                        )}`
                                                                    )
                                                                }
                                                            >
                                                                {props.checkingPhoneNumber(
                                                                    row
                                                                )}
                                                            </Typography>
                                                        </>
                                                    )}
                                                </div>
                                            </TableCell>
                                        )}
                                        {props.role !== "PROVIDER" && (
                                            <TableCell>
                                                <Typography
                                                    sx={{
                                                        "&:hover": {
                                                            cursor:
                                                                row?.provider
                                                                    ?.permalink &&
                                                                "pointer",
                                                            textDecoration:
                                                                row?.provider
                                                                    ?.permalink &&
                                                                "underline"
                                                        }
                                                    }}
                                                    onClick={() =>
                                                        handleProviderPermalinkClick(
                                                            row.provider
                                                                .permalink
                                                        )
                                                    }
                                                >
                                                    {row.providerName || "N/A"}
                                                </Typography>
                                            </TableCell>
                                        )}
                                        <TableCell>
                                            {row.startDateDesc.includes("(")
                                                ? row.startDateDesc.split(
                                                      "("
                                                  )[0]
                                                : row.startDateDesc
                                                  ? row.startDateDesc
                                                  : "N/A"}
                                        </TableCell>
                                        <TableCell>
                                            {row.dateCreated
                                                ? row.dateCreated
                                                : "N/A"}
                                        </TableCell>
                                        <TableCell>
                                            <Typography
                                                sx={{
                                                    maxWidth: "80px",
                                                    backgroundColor:
                                                        row.status ===
                                                        "SCHEDULED"
                                                            ? "primary.light"
                                                            : row.status ===
                                                                "COMPLETED"
                                                              ? "success.light"
                                                              : row.status ===
                                                                  "CANCELLED"
                                                                ? "error.light"
                                                                : "rgba(0,0,0,0.1)",
                                                    color:
                                                        row.status ===
                                                        "SCHEDULED"
                                                            ? "primary.dark"
                                                            : row.status ===
                                                                "COMPLETED"
                                                              ? "success.dark"
                                                              : row.status ===
                                                                  "CANCELLED"
                                                                ? "rgba(255,255,255,0.8)"
                                                                : "rgba(0,0,0,0.5)",
                                                    textTransform: "uppercase",
                                                    padding: "2px",
                                                    borderRadius: "4px",
                                                    textAlign: "center",
                                                    margin:
                                                        row.status.length > 0
                                                            ? "0 auto"
                                                            : "0"
                                                }}
                                                style={{
                                                    fontSize: "0.75rem",
                                                    fontWeight: 600
                                                }}
                                            >
                                                {row.status
                                                    ? row.status === "NOSHOW"
                                                        ? "NO-SHOW"
                                                        : row.status
                                                    : "N/A"}
                                            </Typography>
                                        </TableCell>
                                        {props.role !== "PROVIDER" && (
                                            <TableCell>
                                                <CurrencyFormat
                                                    value={row.initialCharge}
                                                    displayType={"text"}
                                                    thousandSeparator={true}
                                                    prefix={
                                                        row.currencyValue
                                                            ? getCurrencySymbolFromParam(
                                                                  row.currencyValue
                                                              )
                                                            : getCurrencySymbol()
                                                    }
                                                    decimalScale={2}
                                                    fixedDecimalScale={true}
                                                />
                                            </TableCell>
                                        )}
                                        {props.role !== "PROVIDER" && (
                                            <TableCell>
                                                {row.additionalCharges === 0 ? (
                                                    "None"
                                                ) : (
                                                    <CurrencyFormat
                                                        value={
                                                            row.additionalCharges
                                                        }
                                                        displayType={"text"}
                                                        thousandSeparator={true}
                                                        prefix={
                                                            row.currencyValue
                                                                ? getCurrencySymbolFromParam(
                                                                      row.currencyValue
                                                                  )
                                                                : getCurrencySymbol()
                                                        }
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                    />
                                                )}
                                            </TableCell>
                                        )}
                                        {props.role !== "PROVIDER" && (
                                            <TableCell>
                                                {row.ratingstars <= 0 ||
                                                row.ratingstars === ""
                                                    ? "No Rating(s)"
                                                    : props.showRatingStars() && (
                                                          <Rating
                                                              value={
                                                                  row.ratingstars
                                                              }
                                                              precision={0.5}
                                                              size="small"
                                                              readOnly
                                                          />
                                                      )}
                                            </TableCell>
                                        )}
                                        {props.role !== "CLIENT" && (
                                            <TableCell>
                                                <div
                                                    onClick={() => {
                                                        props.showNoteDialog(
                                                            row
                                                        );
                                                    }}
                                                >
                                                    <Tooltip
                                                        title={
                                                            <div
                                                                style={{
                                                                    whiteSpace:
                                                                        "pre-line"
                                                                }}
                                                            >
                                                                {row.note
                                                                    ? row.note
                                                                    : row.order
                                                                            .Notes &&
                                                                        JSON.parse(
                                                                            row
                                                                                .order
                                                                                .Notes
                                                                        )[0]
                                                                            .notes
                                                                      ? JSON.parse(
                                                                            row
                                                                                .order
                                                                                .Notes
                                                                        )[0]
                                                                            .notes
                                                                      : "Click here to add notes"}
                                                            </div>
                                                        }
                                                        placement="right"
                                                        arrow
                                                        TransitionComponent={
                                                            Fade
                                                        }
                                                    >
                                                        <ChatIcon
                                                            style={{
                                                                color: row.note
                                                                    ? row
                                                                          .company
                                                                          .primaryColor
                                                                    : row.order
                                                                            .Notes &&
                                                                        JSON.parse(
                                                                            row
                                                                                .order
                                                                                .Notes
                                                                        )[0]
                                                                            .notes
                                                                      ? row
                                                                            .company
                                                                            .primaryColor
                                                                      : "#c5c5c5",
                                                                cursor: "pointer"
                                                            }}
                                                        />
                                                    </Tooltip>
                                                </div>
                                            </TableCell>
                                        )}
                                        <TableCell>
                                            {row.orderType !==
                                                MB_SERVICE_CLASSIFICATION_GROUP &&
                                                row.status !== "CANCELLED" &&
                                                (row.status !== "NOSHOW" ||
                                                    isVerifiedStaff) &&
                                                (row.status !== "ARRIVED" ||
                                                    !userIsClient) && (
                                                    <>
                                                        <DropDown
                                                            row={row}
                                                            handleArrived={
                                                                props.handleArrived
                                                            }
                                                            handleAddCharge={
                                                                props.handleAddCharge
                                                            }
                                                            handleCompleted={
                                                                props.handleCompleted
                                                            }
                                                            handleCancel={
                                                                props.handleCancel
                                                            }
                                                            handleOverride={
                                                                props.handleOverride
                                                            }
                                                            openRescheduleModal={
                                                                openRescheduleModal
                                                            }
                                                            closeRescheduleModal={
                                                                closeRescheduleModal
                                                            }
                                                            rescheduleModal={
                                                                rescheduleModal
                                                            }
                                                            getSelectedRow={
                                                                getSelectedRow
                                                            }
                                                            refreshTable={
                                                                props.refreshTable
                                                            }
                                                            setShowGetRecurringBookingRescheduleChoiceModal={
                                                                setShowGetRecurringBookingRescheduleChoiceModal
                                                            }
                                                        />
                                                    </>
                                                )}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </TableContainer>
            ) : (
                <ThemeProvider theme={MobileBookingsTheme(theme)}>
                    <Stack>
                        {Object.keys(groupedBookings).map((bookingDate) => (
                            <Fragment key={bookingDate}>
                                {/*Booking date header*/}
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: "500",
                                        textTransform: "uppercase"
                                    }}
                                >
                                    {moment(bookingDate).format("dddd, MMMM D")}
                                </Typography>

                                {/*Bookings for the current date*/}
                                {groupedBookings[bookingDate].map(
                                    (row, index) => (
                                        <MobileBookingCard
                                            key={index}
                                            booking={row}
                                            handleOpenVirtualBookingModal={
                                                handleOpenVirtualBookingModal
                                            }
                                        />
                                    )
                                )}
                            </Fragment>
                        ))}
                    </Stack>
                </ThemeProvider>
            )}

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    [theme.breakpoints.down("sm")]: {
                        flexDirection: "column",
                        alignItems: "stretch",
                        marginTop: "8px"
                    }
                }}
            >
                {props.rows.length !== 0 && (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={props.handleLoadMore}
                        disabled={props.endOfList}
                    >
                        {props.endOfList ? "No More Rows To Load" : "Load More"}
                    </Button>
                )}

                <TablePagination
                    sx={{
                        marginLeft: "auto",
                        [theme.breakpoints.down("sm")]: {
                            marginLeft: "0px"
                        },
                        "& .MuiToolbar-root": {
                            alignItems: "center",
                            [theme.breakpoints.down("sm")]: {
                                padding: "0px",
                                justifyContent: "end"
                            },
                            [theme.breakpoints.down("450")]: {
                                justifyContent: "space-between"
                            },
                            "& .MuiInputBase-root": {
                                fontWeight: 700,
                                [theme.breakpoints.down("sm")]: {
                                    margin: "0px 8px 0px 0px"
                                }
                            },
                            "& .MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows":
                                {
                                    color: "rgba(0,0,0,0.5)",
                                    marginBottom: 0
                                },
                            "& .MuiTablePagination-actions": {
                                display: "flex",
                                gap: "0.5rem",
                                [theme.breakpoints.down("sm")]: {
                                    marginLeft: "8px"
                                },
                                "& button": {
                                    border: "1px solid rgba(0,0,0,0.2)",
                                    borderRadius: "4px"
                                },

                                "& button:hover": {
                                    backgroundColor: "primary.light"
                                }
                            },
                            "& .MuiTablePagination-spacer": {
                                [theme.breakpoints.down("sm")]: {
                                    display: "none"
                                }
                            }
                        }
                    }}
                    component={"div"}
                    rowsPerPageOptions={[5, 10, 25]}
                    count={props.rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Box>
            {loggedInUser?.role === "PROVIDER" &&
                showGetRecurringBookingRescheduleChoiceModal && (
                    <ProviderRecurringRescheduleChoiceModal
                        showGetRecurringBookingRescheduleChoiceModal={
                            showGetRecurringBookingRescheduleChoiceModal
                        }
                        onClose={() =>
                            setShowGetRecurringBookingRescheduleChoiceModal(
                                false
                            )
                        }
                        onContinue={() => {
                            setShowGetRecurringBookingRescheduleChoiceModal(
                                false
                            );
                            setSelectedRescheduleDateTime(
                                new Date(selectedRowData.startdate)
                            );
                            openRescheduleModal();
                        }}
                    />
                )}
            {loggedInUser?.role === "PROVIDER" && rescheduleModal && (
                <ProviderRescheduleModal
                    rescheduleModal={rescheduleModal}
                    openRescheduleModal={openRescheduleModal}
                    closeRescheduleModal={closeRescheduleModal}
                    selectedRowData={selectedRowData}
                    openSnackbar={openSnackbar}
                    refreshTable={props.refreshTable}
                />
            )}
            {loggedInUser?.role === "CLIENT" && clientRescheduleModal && (
                <ClientRescheduleModal
                    rescheduleModal={clientRescheduleModal}
                    openRescheduleModal={openRescheduleModal}
                    closeRescheduleModal={closeRescheduleModal}
                    selectedRowData={selectedRowData}
                    openSnackbar={openSnackbar}
                    refreshTable={props.refreshTable}
                />
            )}
        </>
    );
}

export default BookingsFutureTabTable;
